module.exports = __webpack_public_path__ + "static/media/logo.f081bcb2.svg";